export interface EnvironmentToxinsCondition {
  key: string;
  label: string;
  value: boolean;
  description?: string;
}

// Environment toxins conditions for display
export const ENVIRONMENT_TOXINS_CONDITIONS = [
  { key: "airWaterFilters", label: "Air/Water Filters" },
] as const;

export type EnvironmentToxinsConditionKey =
  (typeof ENVIRONMENT_TOXINS_CONDITIONS)[number]["key"];

// Text fields for environment toxins
export const ENVIRONMENT_TOXINS_TEXT_FIELDS = [
  { key: "home", label: "Home Environment" },
  { key: "chemicalExposure", label: "Chemical Exposure" },
  { key: "additionalInformation", label: "Additional Information" },
] as const;

export type EnvironmentToxinsTextFieldKey =
  (typeof ENVIRONMENT_TOXINS_TEXT_FIELDS)[number]["key"];
